import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LOCAL_STORAGE, LOCAL_STORAGE_STRICT, SESSION_STORAGE, SESSION_STORAGE_STRICT } from './storage/storage.provider';
import { WINDOW, windowFactory } from './window/window.provider';
import { CLIPBOARD, clipboardFactory } from './clipboard/clipboard.provider';


/**
 * A module strictly for test environments.
 *
 * It provides Window, LocalStorage, and SessionStorage with no state-modifying tests.
 *
 * @warning This module assumes your test environment always has both storages available and that they have quota.
 */
@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    { provide: WINDOW, useFactory: windowFactory },
    { provide: LOCAL_STORAGE, useValue: localStorage },
    { provide: LOCAL_STORAGE_STRICT, useValue: localStorage },
    { provide: SESSION_STORAGE, useValue: sessionStorage },
    { provide: SESSION_STORAGE_STRICT, useValue: sessionStorage },
    { provide: CLIPBOARD, useFactory: clipboardFactory, deps: [WINDOW] },
  ],
})
export class DomTestingModule { }
